import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormControl, FormGroup } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'app-creautenteesterno',
  templateUrl: './creautenteesterno.page.html',
  styleUrls: ['./creautenteesterno.page.scss'],
})
export class CreautenteesternoPage implements OnInit {
  validations_form: FormGroup;
  constructor(private fireStore: AngularFirestore, public alertController: AlertController, public modal: ModalController) { }

  ngOnInit() {

    this.validations_form = new FormGroup({
      nome: new FormControl(''),
      cognome: new FormControl(''),
      categoria: new FormControl('Lupino')
    });
  }
  userProfile: any = {};
  crea() {
    // if (!this.validations_form.valid) {
    this.userProfile.nome = this.validations_form.value.nome;
    this.userProfile.cognome = this.validations_form.value.cognome;
    this.userProfile.amministratore = false;
    this.userProfile.categoria = this.validations_form.value.categoria;
    this.userProfile.email = this.userProfile.nome + this.userProfile.cognome + "@xxx.it";

    this.userProfile.uid = uuidv4();

    let obj = {};
    for (let p in this.userProfile) {
      obj[p] = this.userProfile[p];
    }

    console.log(obj);

    this.fireStore.collection<any>('userProfile').add(obj).then(() => {
      this.presentAlert();
      this.modal.dismiss();
    })

    // }
    // else {
    //   this.presentError();
    // }
  }
  // async presentError() {
  //   let obj_alert = {
  //     header: 'Errore',
  //     subHeader: 'Errore',
  //     message: 'Campi obbligatori',
  //     buttons: ['OK']
  //   }

  //   const alert = await this.alertController.create(obj_alert);

  //   await alert.present();
  // }


  async presentAlert() {
    //console.logthis.action);


    let obj_alert = {

      subHeader: 'Creazione',
      message: 'Utente esterno creato con successo',
      backdropDismiss: false,
      buttons: ['OK']
    }
    const alert = await this.alertController.create(obj_alert);
    await alert.present();



  }
  close(){
    this.modal.dismiss();
  }
}
